<template>
    <section class="m-4">
        <h3 class="p-4 text-lg font-bold">Ambassador Tools</h3>
        <div v-if="loaded">
            <div class="md:flex justify-between items-stretch">
                <button @click.prevent="invite" class="mt-2 px-2 py-6 w-full md:w-1/2 bg-gray-light rounded-md text-center border border-gray-darker">
                    <p class="uppercase font-bold">Invites</p>
                    <p class="text-sm">Select your closest people and quickly send an invite.</p>
                </button>

                <button @click.prevent="signature" class="mt-2 md:ml-2 px-2 py-6 w-full md:w-1/2 bg-gray-light rounded-md text-center border border-gray-darker">
                    <p class="uppercase font-bold">Signature</p>
                    <p class="text-sm">Append a link at the bottom of your existing email signature.</p>
                </button>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>
    </section>  
</template>

<script>
import AmbassadorToolInvites from './AmbassadorToolInvites.vue';
import AmbassadorToolSignature from './AmbassadorToolSignature.vue';

export default {
    data() {
        return {
            loaded: true,
        }
    },
    methods: {
        invite() {
            Modal.show(AmbassadorToolInvites)
        },
        signature() {
            Modal.show(AmbassadorToolSignature);
        },
    }
}
</script>